import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Heart } from "lucide-react";

const COLS = [
  { title: "Solutions", to: "/solutions", links: ["Clinical Workflow & EHR", "Smart Telehealth", "Treatment Planning", "Assessments"] },
  { title: "For Families", to: "/for-families", links: ["Parent Portal", "Coaching Hub", "Progress Tracking", "Activities"] },
  { title: "For Providers", to: "/for-providers", links: ["Therapists", "Pediatricians", "Schools & IEP", "Coordination"] },
  { title: "Company", to: "/about", links: ["About", "Careers", "Resources", "Contact"] },
];

export default function Footer() {
  return (
    <footer className="relative mt-6 border-t border-slate-100 bg-gradient-to-b from-white to-[#f2f8ff]">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          <div className="col-span-2">
            <Logo height={48} />
            <p className="mt-4 text-[15px] leading-relaxed text-slate-500 max-w-xs">AI-powered pediatric behavioral health care coordination that connects clinicians, families, and schools for brighter futures.</p>
            <div className="mt-4 font-hand text-[22px] text-[#1a5fd0] flex items-center gap-2"><Heart size={18} className="fill-[#e23b3b] text-[#e23b3b]" /> Healthy Minds, Brighter Futures</div>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <div className="font-display font-bold text-[#10233f] mb-3">{c.title}</div>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l}><Link to={c.to} className="text-[14.5px] text-slate-500 hover:text-[#1a5fd0]">{l}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-slate-100 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-400">© 2025 ProactiveBH. HIPAA Compliant & Secure. All rights reserved.</p>
          <div className="flex gap-6 text-sm text-slate-400">
            <Link to="/about" className="hover:text-[#1a5fd0]">Privacy</Link>
            <Link to="/about" className="hover:text-[#1a5fd0]">Terms</Link>
            <Link to="/about" className="hover:text-[#1a5fd0]">Security</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
